var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.iconPaths),function(iconPath){return _c('span',{key:iconPath,class:'path' + iconPath})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }